import { GYM_FOOD_REPORT_STATUSES, GYM_SEARCH_KINDS } from '@steado/admin-contract/gym-catalog';
import { z } from 'zod';

export const GYM_CATALOG_TABS = ['foods', 'exercises', 'reports', 'misses'] as const;
export type GymCatalogTab = (typeof GYM_CATALOG_TABS)[number];

/**
 * The tab, and each tab's own filter, in the URL: "the reports still open" is
 * a link somebody can paste. Everything `.catch(undefined)`, so a stale link
 * opens the screen on its defaults rather than an error page.
 */
export const gymCatalogSearchSchema = z.object({
  tab: z.enum(GYM_CATALOG_TABS).optional().catch(undefined),
  status: z.enum(GYM_FOOD_REPORT_STATUSES).optional().catch(undefined),
  kind: z.enum(GYM_SEARCH_KINDS).optional().catch(undefined),
});

export type GymCatalogSearch = z.infer<typeof gymCatalogSearchSchema>;
